"use client";

import { useContext } from "react";
import styled from "styled-components";
import { textColorSecondary, accentColorDanger } from "@churchofjesuschrist/eden-style-constants";
import { ValidityStateContext } from "../utils/context";
import { Text5 } from "@churchofjesuschrist/eden-text";
import { jsx as _jsx } from "react/jsx-runtime";
const colorsByValidityState = {
  error: accentColorDanger
};
export const InternalUseOnlyHint = styled(Text5).withConfig({
  componentId: "sc-12eqlx9-0"
})(["display:block;color:", ";"], ({
  $validityState
}) => colorsByValidityState[$validityState] || textColorSecondary);

/**
 * The `Hint` provides a user with helper information about the control it is paired with.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - Content to render inside the Hint Component
 * @returns {React.ReactElement} The Hint component.
 */
const Hint = ({
  children,
  ...props
}) => {
  const validityStateContext = useContext(ValidityStateContext);
  return /*#__PURE__*/_jsx(InternalUseOnlyHint, {
    renderAs: "span",
    $validityState: validityStateContext,
    ...props,
    children: children
  });
};
Hint.displayName = "Hint";
export default Hint;